<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container'">
    <div class="mt-2" style="max-width:597px">
      <h3 style="padding-right: 60px">Endre rekkefølgen av kategorier</h3>
      <div class="dragndrop-info">
        <!-- One sentence per pointer: a finger has to hold first, a mouse does not, and telling
             either one the other's gesture is how «sorteringen virker ikke» starts. -->
        <span class="bo_pointer-fine">Dra og slipp radene for å endre rekkefølgen på hvordan kategoriene vises for brukere i nettbutikken og appene.</span>
        <span class="bo_pointer-coarse">Hold fingeren på en rad til den løfter seg, og dra den dit du vil — slik endrer
          du rekkefølgen på hvordan kategoriene vises for brukere i nettbutikken og appene. Sveiper du raskt, ruller listen i stedet.</span>
        Til slutt trykker du på &laquo;Lagre&raquo; nederst.
      </div>

      <ul id="categoriesList" class="bo_categoriesList">
        <li v-for="category in categories" :key="category.id" :id="category.id" class="category-row">
          <span class="bo_drag-handle"><font-awesome-icon :icon="['fas', 'grip-lines']"/></span>
            <span class="bo_row-label">{{ category.name }}</span>
            <span class="bo_row-move">
              <button type="button" class="icon-btn" aria-label="Flytt opp" @click="moveRowUp($event)"><font-awesome-icon :icon="['fas', 'chevron-up']"/></button>
              <button type="button" class="icon-btn" aria-label="Flytt ned" @click="moveRowDown($event)"><font-awesome-icon :icon="['fas', 'chevron-down']"/></button>
            </span>
        </li>
      </ul>

      <div class="bo_savebtn_container">
        <hr/>
        <button type="button" class="bo_btn" @click="saveOrderOfCategories">Lagre</button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import Sortable from 'sortablejs';
import sortableOptions from "@/util/SortableOptions";
import { moveRowUp, moveRowDown } from "@/util/RowReorder";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,
      categories : []
    };
  },
  mounted() {
    ProductService.getCategories().then(
        (response) => {
          this.categories = response.data;

          this.$nextTick(() => {
            let el = document.getElementById('categoriesList');
            Sortable.create(el, sortableOptions());
          });

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods: {
    // Reordering without a drag — see RowReorder.js for why these move the DOM.
    moveRowUp,
    moveRowDown,

    updateSortOrder(categoryId, sortOrder) {
      //console.log(sortOrder + ' : ' + categoryId);
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id == categoryId) {
          this.categories[i].sortOrder = sortOrder;
          break; //Stop this loop, we found it!
        }
      }
    },
    saveOrderOfCategories(){
      this.loading = true;

      let listItems = document.getElementById('categoriesList').getElementsByTagName('li');
      for (var i = 0; i < listItems.length; i++) {
        let li = listItems[i];
        let categoryId = li.getAttribute('id');
        this.updateSortOrder(categoryId, i);
      }

      ProductService.sortCategories(this.categories).then(
          (response) => {
            if(response.data === "SUCCEEDED"){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Updating sortOrder of categories failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
